import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import { unescapeTags } from '@aytm/lib/common/func'
import { IEcommerceAnswerSchema, IEcommerceQuestionSchema } from '../../types.ts'
import { formatPriceWithLocale } from '../../utils/formatPriceWithLocale.ts'
import { hasDiscount } from '../../utils/hasDiscount.ts'
import style from './ClubcardPrice.module.scss'

interface IClubcardPriceProps {
  schema: IEcommerceQuestionSchema
  answer: IEcommerceAnswerSchema
}

// A Tesco discount is always the Clubcard price: the tag shows it, the saving and the unit price.
const ClubcardPrice = ({ schema, answer }: IClubcardPriceProps) => {
  const { t, languageTag } = useSurveyLocale()
  const viewport = useViewport()
  const price = (value: number) => formatPriceWithLocale(value, schema.price_mask, languageTag, true, false)

  if (!hasDiscount(answer)) return null

  return (
    // An inert link: inside a card its click must not also open the product page.
    <div className={style.clubcardWrap} onClick={event => event.stopPropagation()}>
      <EmptyLink color="#00539f">
        <span className={`${style.clubcard} ${viewport.mobile ? style.mobile : ''}`}>
          <span className={style.clubcardLabel}>{t('questions', 'ec', 'tesco', 'clubcardPrice')}</span>
          <span className={style.clubcardValue}>
            <span className={style.clubcardLines}>
              <span
                className={style.clubcardText}
                dangerouslySetInnerHTML={{
                  __html: `${price(answer.discounted_price)} ${t<(amount: string) => string>(
                    'questions',
                    'ec',
                    'tesco',
                    'save'
                  )(price(answer.price - answer.discounted_price))}`
                }}
              />
              {answer.per_count_price && (
                <span
                  className={style.clubcardUnit}
                  dangerouslySetInnerHTML={{ __html: `(${unescapeTags(answer.per_count_price)})` }}
                />
              )}
            </span>
            <i className={`pi pi-angle-right ${style.clubcardChevron}`} />
          </span>
        </span>
      </EmptyLink>
    </div>
  )
}

export default ClubcardPrice
